import { PageTitle } from "$components/page";
import { styled, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

interface Props {
  title: string;
  pageNumberNumerator: number;
  pageNumberDenominator: number;
}

const Container = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "baseline",
  borderBottom: `1px solid ${theme.palette.divider}`,
  marginBottom: theme.spacing(2),
}));

const Title = styled(PageTitle)({
  borderBottom: "none",
  marginBottom: "unset",
});

const PageNumber = styled(Typography)({
  fontWeight: "bold",
});

export const PageTitleWithPageNumber: FC<Props> = ({
  title,
  pageNumberNumerator,
  pageNumberDenominator,
}) => {
  return (
    <Container>
      <Title>{title}</Title>
      <PageNumber color="textSecondary" variant="body2">
        <FormattedMessage
          id="registration.layout.pageNumber"
          defaultMessage="Page {pageNumberNumerator}/{pageNumberDenominator}"
          values={{ pageNumberNumerator, pageNumberDenominator }}
        />
      </PageNumber>
    </Container>
  );
};
